import { render, staticRenderFns } from "./PageNotice.vue?vue&type=template&id=095cb118"
import script from "./PageNotice.vue?vue&type=script&lang=js"
export * from "./PageNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports